module.exports = __webpack_public_path__ + "4ab43cc9db2814759ac2990c761f60a3.svg";